import { Fragment, useEffect, useState } from "react"
import { Button, DatePicker, Modal, Select, Input, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 }
}

interface Prop {
    serviceRecord?: ServiceRecord
    onChange?: () => void
}

interface ServiceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
}

export default function (prop: Prop) {

    const [employeeList, setEmployeeList] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    useEffect(() => {
        baseAxiosNoInfo('/yuesao_center/global/archives_list', {

        }).then((res: any) => {
            if (res) {
                setEmployeeList(res)
            }
        })

        form.setFieldsValue({
            belong_nursing_id: '',
            service_start_date: '',
            service_days: ''
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/yuesao_center/customer/residence/change_nursing', {
            work_id: prop.serviceRecord?.work_id,
            belong_nursing_id: form.getFieldValue('belong_nursing_id'),
            service_start_date: form.getFieldValue('service_start_date') ? form.getFieldValue('service_start_date').format('YYYY-MM-DD HH:mm:ss') : '',
            service_days: form.getFieldValue('service_days')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 调整护理师 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>调整护理师</Button>

        <Modal title="调整护理师" width={450} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>当前护理模式：{prop.serviceRecord && prop.serviceRecord?.nursing_care_type_desc}</p>
            <p>当前护理师：{prop.serviceRecord && prop.serviceRecord?.belong_nursing_name}</p>
            <p>预计开始日期：{prop.serviceRecord && prop.serviceRecord?.service_start_date}</p>
            <p style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}>注意：请选择护理信息再提交表单！</p>

            <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                <Form.Item required name="service_start_date" label="开始日期" >
                    <DatePicker showTime />
                </Form.Item>

                <Form.Item required name="service_days" label="护理天数">
                    <Input placeholder="请输入天数" />
                </Form.Item>

                <Form.Item required name="belong_nursing_id" label="护理师">
                    <Select showSearch allowClear
                        filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                        {employeeList.map((el: any) => (<Option value={el.id} key={el.id} >{el.user_name}</Option>))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>
}